import type { ReactNode } from 'react';
import { Content } from '../layout';
import { type Card, PreviewCard, Preview3DCard } from './previewCard';

export const PreviewRow = (...cards: Card[]): Card[] => [...cards];

export const PreviewRows = (...rows: Card[][]): Card[][] => [...rows];

interface PreviewSectionProps {
    introduction?: string;
    showIntro: boolean;
    rows: Card[][];
    sticky?: boolean;
    footer?: ReactNode;
    /** Stretch cards to the section width with less padding. */
    fillWidth?: boolean;
}

export const PreviewSection = ({
    introduction,
    showIntro,
    rows,
    sticky = true,
    footer,
    fillWidth = false,
}: PreviewSectionProps) => {
    return (
        <Content.Card size={showIntro || fillWidth ? 'small' : 'large'} sticky={sticky}>
            {showIntro
                ? introduction
                : rows.map((row, index) => (
                      <Content.Section key={index}>
                          {row.map((card) =>
                              card.type === 'preview3d' ? (
                                  <Preview3DCard key={card.title} {...card} />
                              ) : (
                                  <PreviewCard key={card.title} {...card} fillWidth={fillWidth} />
                              ),
                          )}
                      </Content.Section>
                  ))}

            {footer}
        </Content.Card>
    );
};
